import { styled as o } from "styled-components";
import { Star as r } from "./components/Star/index.js";
import { Theme as i } from "../../styles/themes/index.js";
import { MediaQuery as t } from "../../styles/variables.js";
const d = o.div`
  display: flex;
`, m = o(r)`
  font-size: 32px;
  color: rgb(${i.colors.Alpha});

  @media ${t.SCREEN_MD_UP} {
    font-size: 24px;
  }
`, s = o.button`
  display: flex;
  background: none;
  border: 0;
  padding: 4px;
  cursor: pointer;
  line-height: 0;

  @media ${t.SCREEN_MD_UP} {
    padding: 0;
  }
`;
export {
  s as RatingButton,
  d as RatingContainer,
  m as RatingStar
};
